export default "__VITE_ASSET__lMSYWlPE__"